<template>
    <div class="i-all">
        <div class="iall">
            <div class="i-head">
                <div class="banner">
                    <div class="b-body">     
                    </div>
                </div>
            </div>
            <div class="i-body">
                <div class="i-b-one">
                    <div class="i-b-title">客悦AI客服，服务更贴心、营销更精准</div>
                    <div class="i-b-body">
                        <div class="i-b-o-left">
                            <div v-for="(item, index) in pick" :key="index" class="i-b-o-body"
                                @mouseenter="change(index)" ref="body">
                                <div class="i-b-l-name">{{ item.name }}</div>
                                <div class="i-b-l-title">{{ item.title }}</div>
                                <div class="i-b-l-body" v-show="chang == index">
                                    <div v-for="(ite, i) in item.intro" :key="i"><img
                                            src="../assets/img/tick.6ffc6f13.svg" alt="">
                                        <div>{{ ite }}</div>
                                    </div>
                                </div>
                                <div class="i-b-l-foot" v-show="chang == index" @click="jumpd(item)">
                                    <div>了解详情</div><img src="../assets/img/arrowupright.a6c803b1.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="i-b-o-right">
                            <div><img :src="this.pick[this.chang].img" alt=""></div>
                        </div>
                    </div>
                </div>
                <div class="i-b-two">
                    <div class="i-b-title">百度智能云产品</div>
                    <div class="i-b-bodt">
                        <div class="i-b-banner">
                            <div class="i-b-t" v-for="(item, index) in btwo" :key="index">
                                <div class="i-b-name">{{ item.name }}</div>
                                <div class="i-b-t-title">{{ item.title }}</div>
                                <div class="i-b-img"><img :src="item.img" alt=""></div>
                            </div>
                        </div>
                    </div>
                    <div class="i-b-foot">
                        <div class="i-b-freetry"  @click="jump()">免费体验</div>
                    </div>
                </div>
                <div class="i-b-tree">
                    <div class="i-b-title" style="margin-bottom: 20px;">度云科技GEO服务</div>
                    <div class="i-b-bodt">
                        <div class="i-b-t-bd">
                            <div class="i-b-t-left">
                                <div class="i-b-t-l-name ">
                                    <h3>AI可见度监测</h3>
                                </div>
                                <div class="i-b-t-l-title">
                                    <div class="fz">关键信息提及监测</div>
                                    <div class="fz">竞品排名/首推占比</div>
                                    <div class="fz">提问场景下问题监测</div>
                                </div>
                                
                                <div class="i-b-t-free"  @click="jump()">免费体验</div>
                                <div class="i-b-t-l-img"><img
                                        src="https://cdn2.weimob.com/saas/@assets/saas-fe-promotepage-web-stc/pc/_next/static/media/sec3-pic-1@2x.f110ac5c.png"
                                        alt=""></div>
                            </div>
                            <div class="i-b-t-right">
                                <div class="i-b-t-l-name ">
                                    <h3>品牌情绪与口碑</h3>
                                </div>
                                <div class="i-b-t-r-title">
                                    <div class="fz">正负情绪占比</div>
                                    <div class="fz">定位舆情来源</div>
                                    <div class="fz">同步溯源归因</div>
                                </div>
                              
                                <div class="i-b-t-free"  @click="jump()">免费体验</div>
                                <div class="i-b-t-l-img"><img
                                        src="https://cdn2.weimob.com/saas/@assets/saas-fe-promotepage-web-stc/pc/_next/static/media/sec3-pic-2@2x.d4c64946.png"
                                        alt=""></div>
                            </div>
                        </div>
                        <div class="i-b-t-bd">
                            <div class="i-b-t-right">
                                <div class="i-b-t-l-name ">
                                    <h3>引用来源分析</h3>
                                </div>
                                <div class="i-b-t-r-title">
                                    <div class="fz">引用网页/文献定位</div>
                                    <div class="fz">高权威源识别</div>
                                    <div class="fz">信源穿透率</div>
                                </div>
                          
                                <div class="i-b-t-free"  @click="jump()">免费体验</div>
                                <div class="i-b-t-l-img"><img
                                        src="https://cdn2.weimob.com/saas/@assets/saas-fe-promotepage-web-stc/pc/_next/static/media/sec3-pic-3@2x.c0976caf.png"
                                        alt=""></div>
                            </div>
                            <div class="i-b-t-left">
                                <div class="i-b-t-l-name ">
                                    <h3>实时策略优化</h3>
                                </div>
                                <div class="i-b-t-l-title">
                                    <div class="fz">话题/场景覆盖</div>
                                    <div class="fz">知识库智能搭建</div>
                                    <div class="fz">内容创作分发</div>
                                </div>
                            
                                <div class="i-b-t-free"  @click="jump()">免费体验</div>
                                <div class="i-b-t-l-img"><img
                                        src="https://cdn2.weimob.com/saas/@assets/saas-fe-promotepage-web-stc/pc/_next/static/media/sec3-pic-4@2x.74879cfe.png"
                                        alt=""></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Swiper from 'swiper';
export default {
    data() {
        return {
            pick: [{
                name: '智能外呼', title: '比拟真人拨打，大模型理解+数据驱动，应答灵活，助力业务增长。',
                intro: ['高度拟人', "智能触达", '数据驱动'],
                img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/telemarketing.d560bc51.png',
                url:'two',
            }
                , {
                name: '智能客服', title: '运用知识库与业务流程搭建企业专属客服，实现复杂业务自动办理，对话流畅可控、成本更低。',
                intro: ['快速搭建', "对话流畅可控", '交互拟人'],
                img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/unit.4018b506.png',
                url:'one',
            }
                , {
                name: '客户洞察', title: '盘活数据资产，洞察需求偏好，助力企业精准把握营销策略，驱动精细化运营，安全高效，加速转化。',
                intro: ['客户之声', "用户分群", '营销模型'],
                img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/insight.97328aa7.png',
                url:"tree",
            }],
            chang: 0,
            btwo: [{ name: "司南AI审核", title: '精准识别涉黄、涉政、广告、违禁等违规内容', img: "https://website-fe.cdn.bcebos.com/prod/audit-static-website/img/accurate_0f395dd3.png" }
                , { name: "百度千帆大模型平台", title: '以Agent为核心的一站式企业级大模型服务平台', img: "https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/reason2.ac38105f.png" }
                , { name: "文心快码-智能代码助手", title: '从需求到代码的端到端生成，你的新晋编码搭档Zulu正式发布', img: "https://now.bdstatic.com/stash/v1/dc8c989/frontend/92932cd/audio/code-chat-poster.jpg" }
                , { name: "数字员工", title: '懂业务、给结果、可进化的全球首批AI数字员工', img: "https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/reason4.388ecb75.png" }],
            bannerbottom: ["金融", "运营商", "汽车", "能源", "科技", "大消费",],
            banner: [
                {
                    bannerbody: [{ name: '兴业银行', title: '智能语音机器人', word: '提供全渠道智能化客服解决方案，建设全行智能语音平台，实现业务办理、问题咨询等多种智能化服务，节省客服人力，提升工作效率。', bottom: [{ name: '千万量级', title: '智能服务' }, { name: '10+', title: '全行业务渠道覆盖' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_jinrong_xingye01.98e0e80c.png' },
                    { name: '中信金控', title: '财富体验助手', word: '通过数字人多轮对话的形式，收集用户信息问卷，判断用户理财风格与偏好，针对此给出专属的理财建议，帮助用户在理财中作出更好的决策。', bottom: [{ name: '90%+', title: '端到端问答准确率' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_jinrong_zhongxin02.7dc44ecc.png' },],
                },
                {
                    bannerbody: [{ name: '中移在线', title: '智能对话洞察', word: '提供数据采集处理、模型分析和分析任务管理的能力，助力经营优化、提升客户体验和经营效率。', bottom: [{ name: '80%+', title: '标签准确率' }, { name: '50%', title: '响应速度提升' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_yunyingshang_zhongyi01.813d8675.png' },
                    { name: '中国电信', title: '来电秘书', word: '为中国电信手机用户提供“5G+AI”智能个人通信服务产品，包括三大核心功能：漏话提醒、智能应答、留言信箱。重要来电不错过，通信服务安全、便捷、又智能。', bottom: [{ name: '18个', title: '支撑省份区域' }, { name: '150万', title: '支撑用户数量' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_yunyingshan_dianxin02.a55928a3.png' },],
                },
                {
                    bannerbody: [{ name: '奔驰汽车', title: '呼叫中心整合及智能化升级', word: '整合CCC全业务，构建智能电话系统，实现统一接入、监控、运营与安全。项目实施智能化集成方案，打造智能IVR、机器人、知识库等应用，提升客户服务与业务能力，优化运营，全面提升客户服务水平与用户体验。', img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_qiche_benchi01.25cd16b3.png' },
                    { name: '上汽大众', title: '智能化应用平台', word: '通过建设全新的智能化呼叫中心，应用人工智能技术，让坐席服务、IB&OB、质检、客户洞察都实现智能化，帮助呼叫中心大幅提升各项工作的效率，实现售前-售中-售后的闭环服务，达到提高客户满意度、完善客户服务的项目目标。', img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_qiche_dazhong02.c3120fcf.png' },],
                },
                {
                    bannerbody: [{ name: '国家电网', title: '95598智能客服', word: '百度智能云依托AI能力，助力国网客服中心构建AI平台，赋能智能客服、座席与运营，推动95598服务智能化升级。', bottom: [{ name: '93%', title: '意图识别准确率' }, { name: '85%', title: '自助问题解决率' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_nengyuan_guojiadianwang01.533d631d.png' },
                    { name: '中国南方电网', title: '智慧客服', word: '为广东电网打造智能客服，升级热线IVR，构建统一知识库，提升服务效率与质量，创新成果入选信通院优秀案例。', bottom: [{ name: '90%+', title: '意图理解准确率' }, { name: '85%', title: '自助问题解决率' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_nengyuan_nanfang02.f654b3b6.png' },],
                },
                {
                    bannerbody: [{ name: '小度', title: '活动引流加企微', word: '为小度智能终端产品打造的智能外呼服务，协助小度用户添加官方服务号，低成本、高效率持续引流，为后续私域运营打好基础。', bottom: [{ name: '20w+', title: '智能呼叫' }, { name: '50-80%', title: '接通率' }, { name: '15%', title: '转粉率' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_keji_xiaodu01.356e0bf5.png' },
                    { name: '圆心科技', title: '医疗服务回访', word: '与圆心医疗合作，为三甲医院构建智能外呼服务，实现病患医疗回访服务，便于医院及时跟踪病患情况，提供可持续可跟踪的优良医疗服务。', bottom: [{ name: '80%+', title: '接通率' }, { name: '95%+', title: '信息收集完成率' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_keji_yuanxin02.52a0776f.png' },],
                },
                {
                    bannerbody: [{ name: '百胜中国', title: '百胜AIGC智能机器人升级项目', word: '百胜中国携手百度智能云客悦，构建AI智能客服系统，赋能肯德基、必胜客等品牌，提供活动咨询、发票开具、订单变更等服务，提升客服能力与体验。', bottom: [{ name: '95%', title: '回复准确率' }, { name: '90%', title: '自助问题解决率' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_xiaofei_baisheng01.4c19f15e.png' },
                    { name: '德邦快递', title: '德邦快递在线客服项目', word: '通过部署百度智能客服系统，构建"AI+人工"双轨服务体系，搭建物流行业专属话术体系，统一对接微信/支付宝/抖音等10余个服务入口。', bottom: [{ name: '10%', title: '转人工率' }, { name: '10+', title: '服务渠道' }], img: 'https://ky-front-online.cdn.bcebos.com/portal/_next/static/media/img_xaiofei_debang02.197d297e.png' },],
                }

            ],
            time: null,
            long: 0,
            banners: [],
            mySwiper: null,
        }
    },
    methods: {
        jump() {
            if (window.location.href != this.$route.query.id) {
                this.$router.push({ name: 'free', query: { id: window.location.href } })

            }
        },
        jumpd(item){
            if (window.location.href != this.$route.query.id) {
                this.$router.push({ name: item.url, query: { id: window.location.href } })

            }
        },
        change(index) {
            this.chang = index
            for (let c = 0; c < this.pick.length; c++) {
                if (c != index) {
                    this.$refs.body[c].style.borderImage = 'linear-gradient(to bottom, rgba(9, 18, 33, .08), rgba(9, 18, 33, .08))1';
                }
            }
            this.$refs.body[index].style.borderImage = 'linear-gradient(to bottom, #0060ff, #b153ff)1';
        },
        bannerc(index) {
            this.mySwiper.slideToLoop(index, 1000, false)
            for (let c = 0; c < this.bannerbottom.length; c++) {
                if (c != index) {
                    this.$refs.botton[c].style.border = ' 1px solid rgb(205, 205, 205)';
                }
            }
            this.$refs.botton[index].style.border = ' 1px solid black';
        },
        fetchData() {
            // 模拟异步请求
            setTimeout(() => {
                this.banners = [
                    { imgUrl: 'https://via.placeholder.com/800x400?text=Slide+1' },
                    { imgUrl: 'https://via.placeholder.com/800x400?text=Slide+2' },
                    { imgUrl: 'https://via.placeholder.com/800x400?text=Slide+3' },
                ];
            }, 1);
        },
        initSwiper() {
            if (this.mySwiper) {
                this.mySwiper.destroy(); // 销毁旧的Swiper实例
            }
            this.mySwiper = new Swiper('#mySwiper', {
                noSwiping: true,
                loop: true, // 循环模式
                pagination: {
                    el: '.custom-pagination', // 分页器
                    clickable: true,
                    type: 'custom',
                    renderCustom: function () {
                        $('.custom-pagination').on('click', 'li', function () {
                            this.mySwiper.slideToLoop($(this).index(), 1000, false)
                        })


                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next', // 下一页按钮
                    prevEl: '.swiper-button-prev', // 上一页按钮
                },
            });
        },


    },
    mounted() {
        this.$refs.body[0].style.borderImage = 'linear-gradient(to bottom, #0060ff, #b153ff)1';
        this.fetchData();
        this.$refs.botton[0].style.border = ' 1px solid black';
    },
    watch: {
        banners() {
            this.$nextTick(() => {
                this.initSwiper(); // 初始化Swiper
            });
        },
    },
}
</script>

<style lang="scss">
.i-all {
    width: 100%;
    min-width: 1200px;

    .fz {
        font-size: 12px;
    }

    .iall {
        width: 100%;
    }

    .banner {
        background-image: url('../assets/img/背景.png');
        background-size: cover;
        width: 100%;
        height: 580px;
        display: flex;
        background-color: #98c2fe;
        .b-body {
            width: 80%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            margin-top: 80px
        }

        .s-img {
            width: 430px;
        }

        .b-botton {
            width: 100%;
            display: flex;
            margin-top: 22px;

            .b-b-left {
                background-color: #091221;
                margin-right: 12px;
                color: white;
            }

            .b-b-right {
                width: 96px;
                height: 40px;
                border: 1px solid #091221;
                text-align: center;
                line-height: 40px;
                border-radius: 8px;
                font-size: 13px;
                font-weight: 600;
                cursor: pointer;
            }
        }

        .b-left {
            h1 {
                font-size: 40px;
                margin: 0;
                margin-top: 16px;
            }

            .b-l-title {
                color: rgba(9, 18, 33, .7);
                font-size: 12px;
                margin-top: 16px;
            }
        }

        .b-down {
            display: flex;
            margin-top: 36px;

            .b-d-d {
                margin-right: 30px;

                .b-d-title {
                    font-size: 22px;
                    color: #091221;
                    font-weight: 600;
                }

                .b-d-foot {
                    font-size: 12px;
                    color: rgba(9, 18, 33, 0.7);
                }
            }
        }
    }

    .i-body {
        width: 100%;

        .i-b-body {
            width: 80%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            margin-top: 30px;

            .i-b-o-body {
                border-left: 2px solid rgba(9, 18, 33, .08);
                margin-bottom: 30px;
                padding-left: 16px;
                cursor: pointer;
            }



            .i-b-o-left {
                width: 40%;
            }

            .i-b-o-right {
                display: inline-block;

                div {


                    img {
                        width: 550px;
                    }
                }
            }

            .i-b-l-name {
                font-size: 21px;
                font-weight: 600;
                margin-bottom: 8px;
            }

            .i-b-l-title {
                color: rgba(9, 18, 33, 0.7);
                font-size: 12px;
                line-height: 20px;
            }

            .i-b-l-body {
                display: flex;
                margin-top: 8px;

                div {
                    color: rgba(9, 18, 33, 0.7);
                    font-size: 12px;
                    line-height: 12px;
                    display: flex;
                    margin-right: 10px;
                }

                img {
                    margin-right: 3px;
                }
            }

            .i-b-l-foot {
                margin-top: 16px;
                display: flex;

                div {
                    font-size: 12px;
                    font-weight: 600;
                }
            }
        }

        .i-b-one {
            border-radius: 24px 24px 0px 0px;
            width: 100%;
            margin-top: -50px;
            background-color: white;
            display: inline-block;
            padding-bottom: 50px;
        }

        .i-b-title {
            width: 100%;
            text-align: center;
            font-size: 32px;
            font-weight: 600;
            margin-top: 50px;
        }
    }

    .i-b-two {
        border-radius: 24px 24px 0px 0px;
        width: 100%;
        display: inline-block;
        background-color: #f4f6fe;
        padding-bottom: 80px;

        .i-b-foot {
            width: 100%;

            .i-b-freetry {
                width: 150px;
                height: 48px;
                line-height: 48px;
                border: 1px solid black;
                border-radius: 10px;
                margin: 0 auto;
                margin-top: 30px;
                font-size: 16px;
                font-weight: 600;
                text-align: center;
                cursor: pointer;
            }
        }

        .i-b-bodt {
            width: 90%;
            margin: 0 auto;
        }

        .i-b-banner {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 30px;

            .i-b-t {
                width: 24%;
                padding: 35px 0;
                background-color: white;
                border-radius: 10px;

                .i-b-img {
                    width: 200px;
                    margin: 0 auto;

                    img {
                        width: 210px;
                    }
                }

                .i-b-name {
                    width: 220px;
                    margin: 0 auto;
                    font-size: 24px;
                    font-weight: 600;
                    margin-bottom: 10px;
                }

                .i-b-t-title {
                    width: 220px;
                    font-size: 12px;
                    margin: 0 auto;
                    margin-bottom: 15px
                }
            }

        }
    }

    .i-b-tree {
        border-radius: 24px 24px 0px 0px;
        width: 100%;
        margin-top: -30px;
        background-color: white;
        display: inline-block;
        padding-bottom: 50px;

        .i-b-t-bd {
            width: 90%;
            display: flex;
            margin: 0 auto;
            margin-top: 20px;
            justify-content: space-between;

            .i-b-t-l-name {
                font-size: 24px;
                font-weight: 800;

            }

            .i-b-t-free {
                font-size: 15px;
                font-weight: 600;
                color: white;
                padding: 9px 24px;
                background-color: #091221;
                border-radius: 10px;
                display: inline-block;
                margin-top: 10px;
                margin-bottom: 20px;
                cursor: pointer;
            }

            .i-b-t-free:hover {
                background-color: #232a47;
            }

            .i-b-t-l-body {
                color: #595959;
                margin-top: 10px;
            }

            .i-b-t-l-title {
                display: flex;
                margin-top: 6px;

                div {
                    padding: 1px 8px;
                    background-color: #dde2eb;
                    margin-right: 8px;
                    border-radius: 3px;
                }
            }

            .i-b-t-r-title {
                display: flex;
                margin-top: 6px;

                div {
                    padding: 1px 8px;
                    background-color: #cdd9fc;
                    margin-right: 8px;
                    border-radius: 3px;
                }
            }

            .i-b-t-left {
                width: 52%;
                padding: 28px 34px;
                background-color: #f1f4fc;
                border-radius: 16px;

                img {
                    width: 560px;
                }
            }

            .i-b-t-right {
                width: 34%;
                padding: 28px 34px;
                background-color: #e3ebfd;
                border-radius: 16px;

                img {
                    width: 380px;
                }
            }
        }
    }

    .i-b-four {
        border-radius: 24px 24px 0px 0px;
        width: 100%;
        display: inline-block;
        background-color: #e8ecfd;
        padding-bottom: 16px;

    }

    .bannerbody {
        width: 600%;
        display: flex;
        justify-content: space-around;
    }

    .i-b-banner {
        width: 90%;
        overflow: hidden;
        margin: 0 auto;
        margin-top: 26px;

        .i-b-b-body {
            position: relative;
            display: flex;
            width: 600%;
            justify-content: space-around;

            .i-b-b-banner {
                width: 49%;
                border-radius: 10px;
                background-color: white;
                padding-bottom: 20px;

                .ik {
                    width: 94%;
                    margin: 0 auto;
                }

                .i-ban-img {
                    border-radius: 10px;
                    overflow: hidden;
                    margin-top: 20px;
                    margin-bottom: 20px;

                    img {
                        width: 100%;
                    }
                }

                .i-ban-name {
                    font-size: 24px;
                    font-weight: 600;
                }

                .i-ban-body {
                    font-size: 12px;
                    margin-top: 10px;
                }

                .i-b-foot {
                    display: flex;
                    margin-top: 10px;
                }

                .i-b-f-name {
                    font-size: 20px;
                    font-weight: 600;
                }

                .ibft {
                    margin-right: 30px;
                }
            }
        }
    }

    .center {
        border-radius: 24px 24px 0px 0px;
        width: 100%;
        display: inline-block;
        background-color: #e8ecfd;
        padding-bottom: 80px;

        .bannerbody {
            width: 600%;
            display: flex;
            justify-content: space-around;
        }

        .i-b-banner {
            width: 90%;
            overflow: hidden;
            margin: 0 auto;
            margin-top: 26px;

            .i-b-b-body {
                position: relative;
                display: flex;
                width: 600%;
                justify-content: space-around;

                .i-b-b-banner {
                    width: 49%;
                    border-radius: 10px;
                    background-color: white;
                    padding-bottom: 20px;

                    .ik {
                        width: 94%;
                        margin: 0 auto;
                    }

                    .i-ban-img {
                        border-radius: 10px;
                        overflow: hidden;
                        margin-top: 20px;
                        margin-bottom: 20px;

                        img {
                            width: 100%;
                        }
                    }

                    .i-ban-name {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .i-ban-body {
                        font-size: 12px;
                        margin-top: 10px;
                    }

                    .i-b-foot {
                        display: flex;
                        margin-top: 10px;
                    }

                    .i-b-f-name {
                        font-size: 20px;
                        font-weight: 600;
                    }

                    .ibft {
                        margin-right: 30px;
                    }
                }
            }
        }
    }

    .swiper-container {
        width: 100%;

    }

    .swiper-slide img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .i-b-bannerboton {
        display: flex;
        width: 50%;
        margin: 0 auto;
        justify-content: space-around;
        margin-top: 20px;

        div {
            padding: 6px 22px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            cursor: pointer;
            border-radius: 9999px;
            height: 20px;
            line-height: 20px;
            border: 1px solid rgb(205, 205, 205);
        }
    }
}
</style>